module.exports = __webpack_public_path__ + "img/patisserie_du_chef.07af54d7.png";